export default __webpack_public_path__ + "static/media/616.45979402.png";